import React, { useState, useEffect } from "react"
import {
  Table,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Row,
  Col,
} from "reactstrap"
import MetaTags from "react-meta-tags"

import EnvAuditService from "services/applications/envAudit/EnvAuditService"

const envAuditService = new EnvAuditService(
  JSON.parse(localStorage.getItem("authUser"))
)

const ChecklistReviewPage = () => {
  const [questions, setQuestions] = useState([])
  const [modalOpen, setModalOpen] = useState(false)
  const [editQuestion, setEditQuestion] = useState(null)
  const [formValues, setFormValues] = useState({ questions: "", active: true })
  const [showEdit, setshowEdit] = useState(false)

  // Fetch data from endpoint
  useEffect(() => {
    fetchReviewQuestions()
    
  }, [])


  const fetchReviewQuestions = () => {
    envAuditService.getAllChecklistQuestions().then(response => {
      if (response.status) {
        setQuestions(response.data)
      }
    })
  }

  // Toggle modal
  const toggleModal = () => {
    setModalOpen(!modalOpen)
    if (!modalOpen) {
      setFormValues({ questions: "", active: true })
      setEditQuestion(null)
    }
  }

  // Handle form input changes
  const handleInputChange = e => {
    const { name, value, type, checked } = e.target
    setFormValues({
      ...formValues,
      [name]: type === "checkbox" ? checked : value,
    })
  }

  // Handle create or update question
  const handleSubmit = e => {
    e.preventDefault()

    if (editQuestion) {
      envAuditService.updateChecklistQuestion(editQuestion.id, formValues).then(response=>{
        // console.log("response", response)
        if (response.status) {
          // setQuestions(prev => [...prev, newQuestion])
          fetchReviewQuestions()
          toggleModal()
        }
      })
  
    } else {
      // Create new question
      envAuditService.createChecklistQuestion(formValues).then(response=>{
        // console.log("response", response)
        if (response.status) {
          // setQuestions(prev => [...prev, newQuestion])
          fetchReviewQuestions()
          toggleModal()
        }
      })
    }
  }

  // Handle delete question
  const handleDelete = id => {
    if (window.confirm("Are you sure you want to delete this question?")) {
      envAuditService.deleteChecklistQuestion(id).then(response=>{
        // console.log("response", response)
        if (response.status) {
          fetchReviewQuestions()
        } else {
          console.error("Error deleting question:", response)
        }
      })
    }
  }

  // Handle edit button click
  const handleEdit = question => {    
    toggleModal()
    setEditQuestion(question)
    setFormValues({ questions: question.questions, active: question.active })

  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>All Companies</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Checklist Review</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active"></li>
                </ol>
              </Col>
            </Row>
          </div>

          <Row>
            <div className="container">
              <h2></h2>
              <Button color="primary" onClick={toggleModal}>
                Add Question
              </Button>

              <Table className="mt-3" striped>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Question</th>
                    <th>Active</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {questions.map(q => (
                    <tr key={q.id}>
                      <td>{q.id}</td>
                      <td>{q.questions}</td>
                      <td>{q.active ? "Yes" : "No"}</td>
                      <td>
                        <Button
                          color="warning"
                          size="sm"
                          onClick={() => handleEdit(q)}
                        >
                          Edit
                        </Button>{" "}
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => handleDelete(q.id)}
                        >
                          Delete
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <Modal isOpen={modalOpen} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>
                  {editQuestion ? "Edit Question" : "Add Question"}
                </ModalHeader>
                <ModalBody>
                  <Form onSubmit={handleSubmit}>
                    <FormGroup>
                      <Label for="questions">Question</Label>
                      <Input
                        type="text"
                        name="questions"
                        id="questions"
                        value={formValues.questions}
                        onChange={handleInputChange}
                        required
                      />
                    </FormGroup>
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="checkbox"
                          name="active"
                          checked={formValues.active}
                          onChange={handleInputChange}
                        />{" "}
                        Active
                      </Label>
                    </FormGroup>
                  </Form>
                </ModalBody>
                <ModalFooter>
                  <Button color="primary" onClick={handleSubmit}>
                    {editQuestion ? "Update" : "Add"}
                  </Button>{" "}
                  <Button color="secondary" onClick={toggleModal}>
                    Cancel
                  </Button>
                </ModalFooter>
              </Modal>
            </div>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ChecklistReviewPage
